module.exports = __webpack_public_path__ + "img/sevice_1.db6bcaae.png";